import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { useEffect } from 'react'

/**
 * Bridges native app lifecycle events (Capacitor) into the web app.
 * No-ops entirely when running in a regular browser.
 */
export function NativeBridge() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    SplashScreen.hide().catch(() => {})

    const backButtonListener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back()
      } else {
        void CapacitorApp.exitApp()
      }
    })

    return () => {
      void backButtonListener.then((listener) => listener.remove())
    }
  }, [])

  return null
}
